export const DEMOGRAPHICS_DATA: Record<string, string> = {
  "Member Name": "Sarah Johnson",
  "Medicaid ID": "1842849823",
  "Medical Home": "Agency",
  "Network": "NorthEast Care Network",
  "DOB / Age": "03/15/1965 39 years",
  "Sex at Birth": "Female",
  "Race": "Asian",
  "Phone Number": "(745) 289-4745",
  "Address": "2323 Dancing Dove Lane, near Hunte...",
};

export const PCP_DATA: Record<string, string> = {
  "PCP Name": "Dr. Sophia James",
  "Phone Number": "(952) 741-2984",
  "Address": "2323 Dancing Dove Lane",
  "City": "New York",
  "State": "NY",
};

export const HEALTHPLAN_DATA: Record<string, string> = {
  "Health Plan": "Plan-2",
  "Enrollment Start Date": "01/01/2026",
  "Enrollment End Date": "11/30/2027",
  "Member Status": "Active",
};

export const CAREMANAGEMENT_DATA: Record<string, string> = {
  "Agency Name": "Blue Star Health",
  "Agency Address": "2323 Dancing Dove Lane, Long Island...",
  "Care Manager": "Sarah Johnson",
  "Assessment Completion Date": "02/06/2025",
  "CarePlan Completion Date": "02/23/2025",
  "Last Success Contact Date": "02/01/2025",
  "1915i Status": "Active",
  "1915i Status Date": "02/01/2025",
  "Consent Status": "Active",
  "Consent Status Expiry Date": "02/22/2026",
};

export const COST_UTILIZATION_DATA: Record<string, string> = {
  "Inpatient": "$593,734",
  "Outpatient": "$237,134",
  "ED": "$110,816",
  "Pharmacy": "$28,111",
  "Lab": "$415,246",
  "Imaging": "$701,930",
  "Other": "$959,261",
};

export const ADT_ALERTS_DATA = [
  { eventDate: "02/15/2025", eventType: "Admission", eventFacility: "General Hospital" },
  { eventDate: "02/10/2025", eventType: "Discharge", eventFacility: "City Clinic" },
  { eventDate: "02/05/2025", eventType: "Transfer", eventFacility: "Midtown Medical" },
  { eventDate: "01/25/2025", eventType: "Admission", eventFacility: "NorthEast Care Center" },
  { eventDate: "01/15/2025", eventType: "Discharge", eventFacility: "General Hospital" },
  { eventDate: "01/15/2025", eventType: "Discharge", eventFacility: "General Hospital" },
];

export const BEHAVIORAL_HEALTH_DATA = {
  anxiety: true,
  depression: false,
  suAlcohol: true,
  suOther: false,
  suOpioids: false,
  smi: true,
  schizophrenia: false,
  dementia: false,
  bipolarDisorder: true,
  otherMoodDisorders: false,
  idd: false,
  adhd: true,
  eatingDisorders: false,
  autism: false,
  suicidalIdeations: false,
  otherBh: true,
};

export const SDOH_BARRIERS_DATA = {
  educationLiteracy: true,
  employment: false,
  housingShelter: true,
  transportation: true,
  foodResources: false,
  financial: true,
  safetyConcerns: false,
};

export const MEDICAL_DIAGNOSES_DATA = {
  asthma: true,
  cancer: false,
  copd: true,
  diabetes: true,
  chronicKidneyDisease: false,
  heartDisease: true,
  obesity: false,
  arthritis: true,
  hypertension: true,
  osteoporosis: false,
  hepatitis: false,
  hiv: false,
  thyroidDisorders: true,
  parkinsons: false,
  multipleSclerosis: false,
};

export const MEDICATION_FILL_HISTORY_DATA = [
  {
    drug: "ATORVASTATIN 20MG",
    fillDate: "02/15/2025",
    daysSupply: 30,
    prescriber: "Dr. James",
    pharmacy: "CVS Pharmacy",
    class: "Statins",
  },
  {
    drug: "LISINOPRIL 10MG",
    fillDate: "02/10/2025",
    daysSupply: 90,
    prescriber: "Dr. Smith",
    pharmacy: "Walgreens",
    class: "ACE Inhibitors",
  },
  {
    drug: "METFORMIN 500MG",
    fillDate: "02/05/2025",
    daysSupply: 30,
    prescriber: "Dr. James",
    pharmacy: "CVS Pharmacy",
    class: "Biguanides",
  },
  {
    drug: "AMLODIPINE 5MG",
    fillDate: "01/20/2025",
    daysSupply: 90,
    prescriber: "Dr. White",
    pharmacy: "Rite Aid",
    class: "Calcium Channel Blockers",
  },
  {
    drug: "LEVOTHYROXINE 50MCG",
    fillDate: "01/15/2025",
    daysSupply: 30,
    prescriber: "Dr. Lee",
    pharmacy: "CVS Pharmacy",
    class: "Thyroid Hormones",
  },
  {
    drug: "GABAPENTIN 300MG",
    fillDate: "01/05/2025",
    daysSupply: 30,
    prescriber: "Dr. Brown",
    pharmacy: "Walgreens",
    class: "Anticonvulsants",
  },
  {
    drug: "OMEPRAZOLE 20MG",
    fillDate: "12/28/2025",
    daysSupply: 90,
    prescriber: "Dr. Smith",
    pharmacy: "CVS Pharmacy",
    class: "Proton Pump Inhibitors",
  },
  {
    drug: "LOSARTAN 50MG",
    fillDate: "12/15/2025",
    daysSupply: 30,
    prescriber: "Dr. White",
    pharmacy: "Rite Aid",
    class: "Angiotensin II Receptor Blockers",
  },
  {
    drug: "ALBUTEROL HFA",
    fillDate: "04/01/2026",
    daysSupply: 30,
    prescriber: "Dr. Wilson",
    pharmacy: "Walgreens",
    class: "Beta-2 Agonists",
  },
  {
    drug: "SERTRALINE 50MG",
    fillDate: "11/20/2025",
    daysSupply: 30,
    prescriber: "Dr. Taylor",
    pharmacy: "CVS Pharmacy",
    class: "SSRIs",
  },
];

export const IMMUNIZATION_DATA = [
  { vaccine: "Influenza, seasonal, injectable", lastDose: "10/12/2025" },
  { vaccine: "Pneumococcal polysaccharide vaccine", lastDose: "05/20/2025" },
  { vaccine: "Tetanus, diphtheria toxoids", lastDose: "02/15/2026" },
  { vaccine: "Covid-19 Moderna vaccine", lastDose: "02/10/2025" },
  { vaccine: "Shingles (Zoster) vaccine", lastDose: "11/05/2025" },
  { vaccine: "Hepatitis B vaccine", lastDose: "01/22/2026" },
  { vaccine: "MMR vaccine", lastDose: "01/30/2025" },
  { vaccine: "Varicella vaccine", lastDose: "03/12/2025" },
  { vaccine: "HPV vaccine", lastDose: "03/15/2025" },
  { vaccine: "MenACWY vaccine", lastDose: "01/20/2026" },
];

export const REFERRALS_DATA = [
  {
    referralDate: "02/12/2025",
    sendingFacility: "General Hospital",
    receivingFacility: "Specialty Clinic",
    referralType: "Cardiology",
    referralStatus: "Waitlisted",
  },
  {
    referralDate: "02/01/2025",
    sendingFacility: "City Clinic",
    receivingFacility: "Imaging Center",
    referralType: "Radiology",
    referralStatus: "Waitlisted",
  },
  {
    referralDate: "02/01/2026",
    sendingFacility: "Midtown Medical",
    receivingFacility: "Lab Corp",
    referralType: "Internal Medicine",
    referralStatus: "Visited",
  },
  {
    referralDate: "01/10/2025",
    sendingFacility: "NorthEast Care Center",
    receivingFacility: "Physical Therapy Plus",
    referralType: "Orthopedics",
    referralStatus: "Visited",
  },
  {
    referralDate: "12/28/2025",
    sendingFacility: "General Hospital",
    receivingFacility: "Eye Care Center",
    referralType: "Ophthalmology",
    referralStatus: "Waitlisted",
  },
  {
    referralDate: "01/02/2026",
    sendingFacility: "City Clinic",
    receivingFacility: "Dermatology Associates",
    referralType: "Dermatology",
    referralStatus: "Offered",
  },
  {
    referralDate: "01/03/2026",
    sendingFacility: "Midtown Medical",
    receivingFacility: "GI Associates",
    referralType: "Gastroenterology",
    referralStatus: "Visited",
  },
  {
    referralDate: "11/15/2025",
    sendingFacility: "NorthEast Care Center",
    receivingFacility: "Surgery Center",
    referralType: "General Surgery",
    referralStatus: "Waitlisted",
  },
  {
    referralDate: "11/01/2025",
    sendingFacility: "General Hospital",
    receivingFacility: "Nephrology Clinic",
    referralType: "Nephrology",
    referralStatus: "Offered",
  },
  {
    referralDate: "10/20/2025",
    sendingFacility: "City Clinic",
    receivingFacility: "Endocrinology Center",
    referralType: "Endocrinology",
    referralStatus: "Offered",
  },
];

export const CARE_GAPS_DATA = [
  { metricDescription: "Breast Mass Index Assessment (BMI)", metricStatus: "Not Met" },
  { metricDescription: "Hemoglobin A1c Control for Diabetes (HBD)", metricStatus: "Not Met" },
  { metricDescription: "Cholesterol Management (COL)", metricStatus: "Not Met" },
  { metricDescription: "Hemoglobin A1c Control for Diabetes (HBD)", metricStatus: "Met" },
  { metricDescription: "Breast Cancer Screening (BCS)", metricStatus: "Met" },
];

export const RECENT_VISITS_DATA = [
  { date: "02/20/2025", type: "Dental", facility: "Main Street Medical", diagnosis: "D07.3 - Annual Wellness Visit" },
  { date: "01/15/2025", type: "Dental", facility: "Quick Care North", diagnosis: "D07.3 - Upper Respiratory Infection" },
  { date: "02/04/2026", type: "Outpatient", facility: "General Hospital", diagnosis: "D07.8 - Chest Pain" },
  { date: "01/03/2026", type: "Outpatient", facility: "Heart Center", diagnosis: "D50.9 - Palpitations" },
  { date: "10/12/2025", type: "Inpatient", facility: "Imaging Center", diagnosis: "D07.3 - Routine Chest X-Ray" },
];

export const RISK_STRATIFICATION_DATA = [
  { riskDriver: "Diabetes with Complications", trend: "up", color: "red" },
  { riskDriver: "Social Isolation", trend: "no change", color: "yellow" },
  { riskDriver: "Recent Inpatient Admission", trend: "down", color: "green" },
  { riskDriver: "Multiple Chronic Conditions", trend: "up", color: "red" },
  { riskDriver: "Housing Instability", trend: "no change", color: "yellow" },
];

export type LabeledData =
  | typeof DEMOGRAPHICS_DATA
  | typeof PCP_DATA
  | typeof COST_UTILIZATION_DATA;
